// src\components\Admin\Category\LocaleSelector.jsx
import React, { useState, useEffect } from 'react';
import { useAdminStore } from '../../../store/adminStore'; 
import api from '../../../services/apiServices'; // Import your api service
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select'; // The shadcn/ui Select component 
import { Label } from '../../ui/label'; // The shadcn/ui Label component 
import { useNavigate, useParams,useLocation } from 'react-router-dom'; // <-- Import useNavigate, useParams
// --- END NEW IMPORTS ---

const LocaleSelector = () => {
  // --- State from store (no change) ---
  const locale = useAdminStore((state) => state.locale);
  const setLocale = useAdminStore((state) => state.setLocale);
  const countries = useAdminStore((state) => state.countries);
  const setCountries = useAdminStore((state) => state.setCountries);
  const navigate = useNavigate();
  const params = useParams(); // URL params like :locale, :id
  const location = useLocation(); // Current path
  // --- Local state (no change) ---
  const [isLoading, setIsLoading] = useState(false);

  // --- Fetch logic (no change) ---
  useEffect(() => {
    // Only fetch if the countries list is empty
    if (countries.length > 0) {
      return; // Data already loaded
    }

    const fetchCountries = async () => {
      setIsLoading(true);
      try {
        const response = await api.get('/admin/common/active-countries');
        // Save the list to the global store
        setCountries(response.data || []); 
      } catch (err) {
        console.error("Failed to fetch active countries:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCountries();
  }, [countries, setCountries]); // Empty array means this runs only once on mount

  const handleLocaleChange = (newLocale) => {
      if (newLocale && newLocale !== locale) {
        console.log(`LocaleSelector changing locale from '${locale}' to '${newLocale}'`);
        // 1. Update store state
        setLocale(newLocale);

        // 2. Construct the new path
        const currentPath = location.pathname; // e.g., "/admin/categories/manage/IN/view/591/info"
        const pathParts = currentPath.split('/');
        const basePath = "/admin/categories/manage"; // Your defined base path

        // Find the index where the locale *should* be (after 'manage')
        const localeIndex = pathParts.indexOf('manage') + 1;

        let newPath = '';

        if (pathParts.length > localeIndex && pathParts[localeIndex] !== '' && pathParts[localeIndex] !== newLocale) {
            // If there's something at the locale index (and it's not the new locale already),
            // assume it's the old locale and replace it. Keep the rest of the path.
            pathParts[localeIndex] = newLocale;
            newPath = pathParts.join('/');
            console.log(`Navigating: Preserving path, changing locale. New path: ${newPath}`);
        } else if (currentPath === basePath) {
             // If we are exactly on the base path (prompt page), just append the new locale.
             newPath = `${basePath}/${newLocale}`;
             console.log(`Navigating: From base path to new locale. New path: ${newPath}`);
        }
         else {
            // Fallback: If the path structure is unexpected or doesn't contain a locale segment where expected,
            // navigate to the base of the new locale. This handles initial selection or edge cases.
            newPath = `${basePath}/${newLocale}`;
            console.log(`Navigating: Path structure unexpected or initial selection. Defaulting to locale base. New path: ${newPath}`);
        }

        // 3. Navigate
        navigate(newPath);
      }
    };
  return (
    // --- RE-STYLED WRAPPER ---
    // Uses theme variables for card, radius, and border [cite: 5, 16]
    <div className="mb-6 p-4 bg-card rounded-lg border">
      
      <Label htmlFor="locale-selector" className="text-base font-semibold">
        Editing Locale
      </Label>
      
      {/* --- NEW SHADCN/UI SELECT COMPONENT --- */}
      <Select 
        value={locale || ""} // Handle the null state
        onValueChange={handleLocaleChange}
        disabled={isLoading}
      >
        <SelectTrigger id="locale-selector" className="w-full mt-2">
          {/* This will show the placeholder when value is null */}
          <SelectValue placeholder="-- Select a Locale --" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="master">Master</SelectItem>
          {countries.map((country) => (
            <SelectItem key={country.country_code} value={country.country_code}>
              {country.name} ({country.country_code})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {/* --- END NEW COMPONENT --- */}

      {isLoading && (
        // --- RE-STYLED LOADING TEXT ---
        // Uses text-muted-foreground for proper theme color 
        <p className="mt-2 text-sm text-muted-foreground"> 
          Loading countries...
        </p>
      )}
    </div>
  );
};

export default LocaleSelector;